import { createGtm } from "@gtm-support/vue-gtm";

export default defineNuxtPlugin((nuxtApp) => {
  const { public: publicConfig } = useRuntimeConfig();
  if (publicConfig.nuxtEnv === "prod") {
    // useHead({
    //   script: [
    //     {
    //       innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src="https://sst.boostingmarket.com/ahilsdwlj.js?"+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','3jsu=aWQ9R1RNLU5OTkNNNjQ%3D&page=2');`,
    //     },
    //   ],
    // });
  } else if (publicConfig.nuxtEnv === "dev") {
//     useHead({
//       script: [
//         {
//           innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
// new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
// j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
// 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
// })(window,document,'script','dataLayer','GTM-56FW2T5C');`,
//         },
//       ],
//     });
  }
});
